"use strict";
exports.__esModule = true;
exports.ExpressionNodeEvaluator = exports.ExpressionNodeType = void 0;
var ExpressionNodeType;
(function (ExpressionNodeType) {
    ExpressionNodeType["Array"] = "ArrayExpression";
    ExpressionNodeType["Binary"] = "BinaryExpression";
    ExpressionNodeType["Call"] = "CallExpression";
    ExpressionNodeType["Compound"] = "Compound";
    ExpressionNodeType["Conditional"] = "ConditionalExpression";
    ExpressionNodeType["Identifier"] = "Identifier";
    ExpressionNodeType["Literal"] = "Literal";
    ExpressionNodeType["Member"] = "MemberExpression";
    ExpressionNodeType["Sequence"] = "SequenceExpression";
    ExpressionNodeType["This"] = "ThisExpression";
    ExpressionNodeType["Unary"] = "UnaryExpression";
})(ExpressionNodeType = exports.ExpressionNodeType || (exports.ExpressionNodeType = {}));
var ExpressionNodeEvaluator = (function () {
    function ExpressionNodeEvaluator(evaluator, context) {
        this.evaluator = evaluator;
        this.context = context;
    }
    return ExpressionNodeEvaluator;
}());
exports.ExpressionNodeEvaluator = ExpressionNodeEvaluator;
//# sourceMappingURL=node.js.map